import CONFIGURACIONES from "../../../../util/constants";
import WaveButton from "../../../global/WaveButton";

import { useForm, useFieldArray } from "react-hook-form";
import React, {useEffect, useState} from "react";
import OWASP from "../../../../util/owasp";


const MantTransactionCredit = ( {MySwal, title, idEdit, colaborador, tiposDocumento, fnBuscar, showCreate, showDelete, icon, dataCreditos, solicitudId, handleCheck, handleCronograma, handleExtornar, setElementActive, solicitud}) => {

    const { handleSubmit, reset, register, setValue, formState: { errors } } = useForm({mode: "onChange"});
    
    const [tipoBq, setTipoBq] = useState(CONFIGURACIONES.INIT.STRING);
    const [patronDocumento, setPatronDocumento] = useState(CONFIGURACIONES.INIT.STRING);
    const [showOptions, setshowOptions] = useState(CONFIGURACIONES.INIT.STATUS_TRUE);

    const onSubmit1 = (form) => {
    };

    useEffect(() => {
        setshowOptions(CONFIGURACIONES.INIT.STATUS_TRUE);
        if (solicitud !== CONFIGURACIONES.INIT.NULL) {
            setshowOptions((solicitud.estadoDesembolsoId == CONFIGURACIONES.INIT.ESTADOS_DESEMBOLSO.ESTADO_EXTORNO?CONFIGURACIONES.INIT.STATUS_FALSE:CONFIGURACIONES.INIT.STATUS_TRUE));
        }
    }, [solicitud])

    return (
        <>
        { idEdit >= CONFIGURACIONES.INIT.NUMBER && <>
            <div className="card-content">
                <form action="" className="form" onSubmit={handleSubmit(onSubmit1)} autoComplete="off">
                    <div className="row">
                        <div className="col-xs-12 col-md-11"> 
                            <h5 className="card-title font-weight-bold"><i className={`mdi ${icon}`}></i> {title}</h5>
                            <div className="row">
                                <div className="col-sm-12 col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="tipoBusqueda" className="control-label col-form-label">Buscar por <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("tipoBusqueda", {
                                                required: OWASP.REQUIRED,
                                                onChange: (e) => {
                                                    setTipoBq(e.target.value);
                                                }
                                            })} className="form-control" id="tipoBusqueda" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                                
                                            {
                                                CONFIGURACIONES.INIT.LIST.TIPOS_BUSQUEDA_TRANSACCIONES.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.tipoBusqueda && errors.tipoBusqueda.message }</small>
                                    </div>
                                </div>
                                
                                { tipoBq === CONFIGURACIONES.INIT.TYPE_BQ_C && (
                                    <div className="col-sm-12 col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="tipoDocumentoRefId" className="control-label col-form-label">Tipo de Documento <span className="text-danger">*</span></label>
                                            <select 
                                                {...register("tipoDocumentoRefId", {
                                                    required: OWASP.REQUIRED,
                                                    onChange:(e) => {
                                                        setPatronDocumento(new RegExp(e.target.value.split('@@')[1]));
                                                        setValue("tipoDocumentoId", e.target.value.split('@@')[0]);
                                                    }
                                                })} className="form-control" id="tipoDocumentoRefId" 
                                                placeholder="" defaultValue={""}
                                            >
                                                <option value="" disabled>Seleccione</option>
                                                {
                                                    tiposDocumento.map((el, index) => (
                                                        <option key={index} value={`${el.id}@@${el.patron_validacion}`}>{el.nombre}</option>
                                                    ))
                                                }
                                            </select>
                                            <input  
                                                {...register("tipoDocumentoId", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                                id="tipoDocumentoId"
                                                type="hidden" />
                                            <small className="invalid-feedback"> { errors.tipoDocumentoId && errors.tipoDocumentoId.message }</small>
                                        </div>
                                    </div>
                                )}

                                { tipoBq === CONFIGURACIONES.INIT.TYPE_BQ_C && (
                                    <div className="col-sm-12 col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="numeroDocumento" className="control-label col-form-label">Documento <span className="text-danger">*</span></label>
                                            <input 
                                                {...register("numeroDocumento", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: patronDocumento,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    },
                                                })}
                                                type="text" className="form-control" id="numeroDocumento" placeholder="" />
                                            <small className="invalid-feedback"> { errors.numeroDocumento && errors.numeroDocumento.message }</small>
                                        </div>
                                    </div>
                                )}

                                { tipoBq === CONFIGURACIONES.INIT.TYPE_BQ_S && (
                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="numSolicitud" className="control-label col-form-label">Num. de Solicitud <span className="text-danger">*</span></label>
                                            <input 
                                                {...register("numSolicitud", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.GENERAL,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    },
                                                })}
                                                type="text" className="form-control" id="numSolicitud" placeholder="" />
                                            <small className="invalid-feedback"> { errors.numSolicitud && errors.numSolicitud.message }</small>
                                        </div>
                                    </div>
                                )}
                                
                                <div className="col-sm-1 my-auto pt-3">
                                    <button type="button" className="btn btn-sm btn-info" onClick={fnBuscar}>
                                        <i className="mdi mdi-magnify"></i>
                                    </button>
                                </div>
                            </div>

                            <div className="row">
                                {colaborador && <div className="col-xs-12 col-md-5">
                                    <div className="form-group">
                                        <label htmlFor="cliente" className="control-label col-form-label">Cliente</label>
                                        <input type="text" className="form-control" id="cliente" value={cliente.nombreCompleto} placeholder="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE} /> 

                                    </div>
                                </div>}
                                
                                <div className="col-md-12">
                                    {/* Tabla */}
                                    <div className="table-responsive">
                                        <table className="table table-bordered compact-table align-middle text-nowrap">
                                            <thead className="bg-success text-white">
                                            <tr>
                                                <th className="text-center">Seleccionar</th>
                                                <th>Num. de Solicitud</th>
                                                <th>Fecha de Desembolso</th>
                                                <th>Monto Desembolsado</th>
                                                <th>Cuota</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {dataCreditos.length > 0? (
                                                dataCreditos.map((el, index) => (
                                                    <React.Fragment key={index}>
                                                    <tr>
                                                        <td className="text-center">
                                                            <input type="radio" className="text-center" checked={el.id === solicitudId} onChange={() => {handleCheck(el.id); setElementActive(el);} }/>
                                                        </td>
                                                        <td>{el.numSolicitud}</td>
                                                        <td>{el.fechaDesembolso}</td>
                                                        <td>{el.montoSolicitado}</td>
                                                        <td>{el.cuota}</td>
                                                    </tr>
                                                    </React.Fragment>))
                                            ): (<tr><td className="align-middle p-2 bg-white text-danger font-bold" colSpan={5}>{CONFIGURACIONES.MESSAGES.LIST_EMPTY}</td></tr>)}

                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="action-form mt-3 d-flex justify-content-start">
                        <div className="form-group mb-0 text-left">
                            {showOptions && showCreate && solicitudId !== CONFIGURACIONES.INIT.NUMBER && <WaveButton type="button" className="btn btn-sm btn-outline-info waves-effect" onClick={handleCronograma}>
                                <i className="mdi mdi-information-outline"></i> Ver Cronograma
                            </WaveButton>}

                            {showOptions && showDelete && solicitudId !== CONFIGURACIONES.INIT.NUMBER && <WaveButton type="button" className="btn btn-sm btn-outline-danger waves-effect ml-1" onClick={handleExtornar}>
                                <i className="mdi mdi-delete"></i> Extornar Desembolso
                            </WaveButton>}
                        </div>
                    </div>
                </form>
            </div>
            </>
        }
        </>
    )
}
export default MantTransactionCredit;